import * as utilConstants from "../constants/utilsConstants";


export function IsEmpty(value) {
    if (
      value === undefined ||
      value === null ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim().length === 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  export function IsValidEmail(email) {
    var myRegEx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-use-before-define
    var isemail = myRegEx.test(email);
    if (isemail) {
      return true;
    } else {
      return false;
    }
  }

  export function passwordStrength(password) {
    let strongPassword = new RegExp(utilConstants.strongPasswordRegex); 
    let mediumPassword = new RegExp(utilConstants.mediumPasswordRegex); 
  
    if (strongPassword.test(password))
      return utilConstants.getStrongPasswordStatus;
    else if (mediumPassword.test(password))
      return utilConstants.getMediumPasswordStatus;
    else return utilConstants.getWeakPasswordStatus;
  }

  export function IsValidPhone(phone) {
    const phoneRegex = /^\+[1-9]\d{10,14}$/; 
    // Validates international phone numbers (e.g., +911234567890)
    return phoneRegex.test(phone);
  }

  

  export function timeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} sec${diffInSeconds !== 1 ? "s" : ""} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} min${diffInMinutes !== 1 ? "s" : ""} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths !== 1 ? "s" : ""} ago`;
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return `${diffInYears} year${diffInYears !== 1 ? "s" : ""} ago`;
}


export function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export const scrollToError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (firstErrorField) {
        const element = document.querySelector(`[name="${firstErrorField}"]`);
        if (element) {
            element.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center',
                inline: 'nearest'
            });
            setTimeout(() => element.focus(), 300);
        }
    }
};


export const parseSheetBackendErrors = (errorData) => {
    const errors = [];
    console.log(errorData, 'ff')
  
  // Handle top-level non_field_errors
  if (errorData.non_field_errors && Array.isArray(errorData.non_field_errors)) {
    errorData.non_field_errors.forEach(error => {
      errors.push(error);
    });
  }
  
  // Handle rows errors
  if (errorData.rows && Array.isArray(errorData.rows)) {
    errorData.rows.forEach((row, rowIndex) => {
      // Skip empty objects
      if (!row || Object.keys(row).length === 0) return;
      
      Object.keys(row).forEach(field => {
        if (Array.isArray(row[field])) {
          // Handle nested time_frame_data errors
          if (field === 'time_frame_data' && typeof row[field][0] === 'object') {
            row[field].forEach((timeFrame, tfIndex) => {
              if (timeFrame && Object.keys(timeFrame).length > 0) {
                Object.keys(timeFrame).forEach(tfField => {
                  if (Array.isArray(timeFrame[tfField])) {
                    errors.push(`Row ${rowIndex + 1}, Time Frame ${tfIndex + 1}: ${tfField} - ${timeFrame[tfField][0]}`);
                  }
                });
              }
            });
          } else if (field === 'non_field_errors') {
            // Handle row-level non_field_errors
            errors.push(`Row ${rowIndex + 1}: ${row[field][0]}`);
          } else {
            // Handle regular field errors
            errors.push(`Row ${rowIndex + 1}: ${field} - ${row[field][0]}`);
          }
        }
      });
    });
  }
  
  // Handle cells errors
  if (errorData.cells && Array.isArray(errorData.cells)) {
    errorData.cells.forEach((cell, cellIndex) => {
      // Skip empty objects
      if (!cell || Object.keys(cell).length === 0) return;
      
      Object.keys(cell).forEach(field => {
        if (Array.isArray(cell[field])) {
          if (field === 'non_field_errors') {
            errors.push(`Cell ${cellIndex + 1}: ${cell[field][0]}`);
          } else {
            errors.push(`Cell ${cellIndex + 1}: ${field} - ${cell[field][0]}`);
          }
        }
      });
    });
  }
  
  return errors;
};


//  Date formater with time 

export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };
    return date.toLocaleDateString('en-US', options).replace(',', '');
};


  
  